import React from "react";

import { TimeSeriesLines } from "../charts/TimeSeriesLines";
import { ChartLayout, formatterFromTickformat, getChartColor, layoutHeight, layoutWidth, seriesFromTimeSeries } from "../charts/chartTheme";

interface IValuePerformanceTimeSeriesChartProps {
    value: any;
    style?: React.CSSProperties | undefined;
    layout?: ChartLayout;
}

export const ValuePerformanceTimeSeriesChart = ({ value, layout, style }: IValuePerformanceTimeSeriesChartProps): React.ReactElement => {
    const portf = value;
    let ts1 = portf.returnTimeSeries;
    ts1 = ts1.mult(1 / ts1.startValue);
    const ts1m1 = ts1.add(-1);
    const series = [seriesFromTimeSeries(ts1m1, getChartColor(0))];
    series[0].name = portf.name;
    const max = ts1m1.values.reduce((previous, current) => Math.max(Math.abs(current), previous), 0);
    if (portf.benchmarkTimeSeries && portf.benchmarkTimeSeries.length > 0) {
        let ts2 = portf.benchmarkTimeSeries;
        ts2 = ts2.range(ts1.start, ts1.end);
        ts2 = ts2.mult(ts1.latestValue(ts2.start) / ts2.startValue);
        const benchmark = seriesFromTimeSeries(ts2.add(-1), "rgba(120, 20, 130, .7)");
        benchmark.name = portf.benchmarkName;
        benchmark.dash = true;
        series.push(benchmark);
    }

    return (
        <TimeSeriesLines
            series={series}
            yFormat={formatterFromTickformat(max < 0.06 ? ".1%" : ".0%")}
            showLegend={layout?.showlegend ?? true}
            legendPosition={layout?.legendPosition ?? "top"}
            ariaLabel={portf.name || "Performance"}
            height={layoutHeight(layout, 320)}
            width={layoutWidth(layout)}
            style={style}
        />
    );
};
